import { client } from './client';

class problemsApi {

    static async getAll() {
        let problems = await client.get('/problems', {
            params: {
                isActive: true
            }
        });

        return problems.data;
    }

    static async getProblemsForOverviewMap() {
        let problems = await client.get('/problems', {
            params: {
                isActive: true,
                statuses: ['Registreeritud', 'Tegeletakse']
            }
        });

        return problems.data;
    }

    static async getActiveProblemsInRadius(radiusM, x, y, problemType) {
        let problems = await client.get('/problems/in_radius', {
            params: {
                radiusM: radiusM,
                x: x,
                y: y,
                problemType: problemType
            }
        });

        return problems.data;
    }

    static async getProblemFilters() {
        let problemFilters = await client.get('/problem_filters');

        return problemFilters.data;
    }

    static async getById(id) {
        let problem = await client.get('/problems/' + id);

        return problem.data;
    }

    static async publicShow(id) {
        let problem = await client.get('/problems/' + id + '/public');
        return problem.data;
    }

    static async getProblemPlannedDateHistory(id) {
        let logs = await client.get('/problems/' + id + '/history/planned_date');

        return logs.data;
    }

    static async getCreatedBy(id) {
        let createdBy = await client.get('/problems/' + id + '/created_by');

        return createdBy.data;
    }

    static async setProblemStatus(problemId, statusId) {
        let response;
        response = await client.put('/problems', {
            problemId: problemId,
            statusId: statusId
        });

        return response.data;
    }

    static async setProblemCityPart(problemId, cityPartId) {
        let response;
        response = await client.put('/problems', {
            problemId: problemId,
            cityPartId: cityPartId
        });

        return response.data;
    }

    static async setProblemIsPrivate(problemId, isPrivate) {
        let response;
        response = await client.put('/problems', {
            problemId: problemId,
            isPrivate: isPrivate
        });

        return response.data;
    }

    static async setIsFixedOwner(problemId, isFixed) {
        let response;
        response = await client.put('/problems', {
            problemId: problemId,
            isFixedOwner: isFixed
        });

        return response.data;
    }

    static async setProblemObjectOwner(problemId, objectOwnerId, objectOwnerType) {
        let response;
        response = await client.put('/problems', {
            problemId: problemId,
            objectOwnerId: objectOwnerId,
            objectOwnerType: objectOwnerType
        });

        return response.data;
    }

    static async setProblemCoordinates(problemId, coordinates) {
        let response;
        response = await client.put('/problems', {
            problemId: problemId,
            coordinates: coordinates
        });

        return response.data;
    }

    static async setProblemAddress(problemId, address) {
        let response;
        response = await client.put('/problems', {
            problemId: problemId,
            address: address
        });

        return response.data;
    }

    static async setRepairHours(problemId, hours) {
        let response;
        response = await client.put('/problems', {
            problemId: problemId,
            hours: hours
        });

        return response.data;
    }

    static async setProblemPlannedDates(problemId, model) {
        let response;

        response = await client.put('/problems', {
            problemId: problemId,
            plannedDates: model
        });

        return response.data;
    }

    static async setProblemType(problemId, typeId, groupId) {
        let response;
        response = await client.put('/problems', {
            problemId: problemId,
            typeId: typeId,
            groupId: groupId
        });

        return response.data;
    }

    static async setProblemDescription(problemId, description) {
        let response;
        response = await client.put('/problems', {
            problemId: problemId,
            description: description
        });

        return response.data;
    }

    /**
     * Set responsible department
     * @param problemId
     * @param departmentId
     * @returns {Promise<T>}
     */
    static async setResponsibleDepartment(problemId, departmentId) {
        let response;
        response = await client.put('/problems', {
            problemId: problemId,
            responsibleDepartment: departmentId
        });

        return response.data;
    }

    static async createComment(problemId, parentCommentId, text) {
        let response;
        response = await client.post('/problem_comments', {
            problemId: problemId,
            parentCommentId: parentCommentId,
            text: text
        });

        return response.data;
    }

    static async createPublicComment(model) {
        let response;
        response = await client.post('/problem_comments/public', model);

        return response.data;
    }

    static async deleteComment(commentId) {
        let response;
        response = await client.delete('/problem_comments/' + commentId);

        return response.data;
    }

    static async create(model) {
        let problem = await client.post('/problems', model);
        return problem.data;
    }

    // Update problem by id
    static async update(id, model) {
        let result = await client.put('/problems/' + id, model);
        return result.data;
    }

    static async changeProblemState(model) {
        let problemState = await client.put('/problems/state/' + model.id, model);
        return problemState.data;
    }

    static async get(filters) {
        let response = await client.post('/problems/search', filters);
        return response.data;
    }

    static async getOverallStatistics(filters) {
        let response = await client.post('/problems/statistics', filters);
        return response.data;
    }

    static async saveRoadSigns(model) {
        let response = await client.post('/problem/road_sign/save', model);
        return response.data;
    }

    static async autoSaveRoadSigns(model) {
        let response = await client.post('/problem/road_sign/autosave', model);
        return response.data;
    }

    static async getProblemRoadSigns(problemId) {
        let response = await client.get('/problems/signs/:id'.replace(':id', problemId));
        return response.data;
    }

    static async addChildProblem(problemId, childProblemId) {
        let response;
        response = await client.put('/problems', {
            problemId: problemId,
            childProblemId: childProblemId
        });

        return response.data;
    }

    static async removeDuplicateProblemRelation(problemId) {
        let response;
        response = await client.put('/problems', {
            problemId: problemId,
            removeDuplicateProblemRelation: true
        });

        return response.data;
    }

    /**
     * Create public problem by object
     * @param model
     * @returns {Promise<*>}
     */
    static async createPublic(model) {
        let response = await client.post('/public/problems', model);
        return response.data;
    }

    static async setProblemResponsible(problemId, companyId) {
        let response;
        response = await client.put('/problems', {
            problemId: problemId,
            responsibleCompanyId: companyId
        });

        return response.data;
    }

    /**
     * Get problem authors by name (person, company, department)
     * @param name
     * @returns {Promise<*>}
     */
    static async getAuthors(name) {
        let response = await client.get('/problems/authors', { params: { name } });
        return response.data;
    }

    /**
     * Export to file
     * @returns {Promise<any>}
     * @param ids
     * @param type
     */
    static async exportToFile(ids, type) {
        let response = await client.post('/problems/export', { ids, type });
        return response.data;
    }

    /**
     * Check export to file
     * @returns {Promise<any>}
     * @param id
     */
    static async checkExportToFile(id) {
        let response = await client.get('/problems/export/check', { params: { id } });
        return response.data;
    }

    static async createProblemFromReport(id) {
        let response = await client.post('/problems/from_citizen/', { id });
        return response.data;
    }
}

export default problemsApi;
